import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as ArrowUp } from "../../../assets/dashboard/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../assets/dashboard/arrow-down.svg";
import { ReactComponent as Rectangle } from "../../../assets/dashboard/rectangle.svg";



const getColor = (diff) => {
  if (diff > 0) return "#E4D354";
  if (diff < 0) return "#E45454";
  return "#14C52F";
};
const parseHHMMSS = (timeStr) => {
  if (!timeStr) return { hours: 0, minutes: 0, seconds: 0, totalMinutes: 0, raw: "0 MIN" };
  const [h, m, s] = timeStr.split(":").map(Number);
  const totalMinutes = h * 60 + m + s / 60;
  return { hours: h, minutes: m, seconds: s, totalMinutes, raw: timeStr };
};
const getIdleSVG = (minutes, benchmarkMinutes) => {
  if (minutes < benchmarkMinutes) return <Rectangle style={{color:'#14C52F' }} />;
  if (minutes > benchmarkMinutes) return <Rectangle style={{ color: "#E45454" }} />;
  return <Rectangle style={{ color: "#E4D354" }} />;
};
export default function MetricCell({ metric,themecolors }) {
  const getTrendIcon = (trend, diff) => {
    const color = getColor(diff);
    if (trend === "up") return <ArrowUp style={{ fontSize: 18, color }} />;
    if (trend === "down") return <ArrowDown style={{ fontSize: 18, color }} />;
    return <Rectangle style={{ fontSize: 18, color }} />;
  };
  

  const isAvgIdle = typeof metric.value === "string";
  const isNumericBenchmark = typeof metric.benchmark === "number";

            const idle = isAvgIdle ? parseHHMMSS(metric.value) : null;
            const benchmark = isAvgIdle ? parseHHMMSS(metric.benchmark) : null;
            const idleMinutes = idle?.totalMinutes?Number(idle.totalMinutes):0;
const benchmarkMinutesNum =benchmark?.totalMinutes? Number(benchmark.totalMinutes):0;

  return (
    <Box
      sx={{
        py: { xs: 0, sm: 0 },
        px: { xs: 0, sm: 1.5 },
        minHeight: { xs: 60, sm: 70 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 0.5, sm: 1 },
          mb: 0,
        }}
      >
        {
          isAvgIdle?
getIdleSVG(idleMinutes,benchmarkMinutesNum):
          getTrendIcon(metric.trend, metric.diff)}
        
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 18 },
            fontWeight: 600,
            color:themecolors?.textColor|| "#fff",
          }}
        >
          {isAvgIdle ? metric.value : `${metric.value}%`}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: { xs: 12, sm: 14 },
          fontStyle: "italic",
          fontWeight: "light",
          color: "#fff",
        }}
      >
        Benchmark{" "}
        <Typography
          component="span"
          sx={{
            fontSize: { xs: 14, sm: 18 },
            fontWeight: 600,
            fontStyle: "normal",
          }}
        >
          {metric.benchmark}
          {!isAvgIdle && isNumericBenchmark ? "%" : ""}
        </Typography>
      </Typography>
    </Box>
  );
}